import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { Container, Row } from "reactstrap";
import BarDetailForm from "./BarDetailForm";

registerLocale("en", en);
registerLocale("ko", ko);

interface OverviewProps {
  barId?: string;
  setLinkImage: any;
  setTitleBarDetail?: any;
}

const Overview = ({ barId, setLinkImage, setTitleBarDetail }: OverviewProps) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = `${t("Overview")} - ${t("Bar Detail")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <Row>
            <BarDetailForm id={barId} setLinkImage={setLinkImage} setTitleBarDetail={setTitleBarDetail} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Overview;
